module.exports = __webpack_public_path__ + "static/media/partner-4.84420e95.png";